<template>
  <div class="relative mb-12" style="padding-bottom: 12px; background-color: #eff0f4">
    <!-- 轮播 -->
    <div class="absolute top-bg"></div>
    <div class="p-3">
      <div class="w-full" style="height: 195px">
        <van-swipe class="my-swipe" indicator-color="#42A6FF" :autoplay="3000">
          <van-swipe-item v-for="(slide, index) in adList" :key="index">
            <a :href="slide.advertUrl">
              <van-image width="100%" height="100%" fit="fill" :radius="6" :src="slide.picUrl" />
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- 停车缴费 payForOthers-->
    <platenoInput v-if="payForOthers === 1" />
    <!-- 菜单图标 -->
    <div class="mt-3 px-3">
      <div class="flex flex-row flex-wrap">
        <div
          v-for="(item, index) in loopList"
          :key="index"
          class="flex flex-col justify-center items-center mb-3"
          :style="{'flex-basis':(100/column)+'%' }"
          @click="goNewPage(item)"
        >
          <img :src="item.icon" alt="" style="width: 60px; height: 60px" />
          <p class="mt-2 text-xs text-gray-700">{{ item.entryName }}</p>
        </div>
        <div
          class="flex flex-col justify-center items-center mb-3"
          :style="{'flex-basis':(100/column)+'%' }"
          @click="goMenuAll"
        >
          <img src="@/assets/all.png" alt="" style="width: 60px; height: 60px" />
          <p class="mt-2 text-xs text-gray-700">全部应用</p>
        </div>
      </div>
    </div>
    <!-- 历史欠费 homeParkingCharge-->
    <div v-if="msg && homeParkingCharge === 1 && platBizType !== 2" class="px-3">
      <div
        class="flex flex-row justify-between items-center text-sm bg-white rounded-md arrears-hint"
        @click="goPay"
      >
        <div class="flex flex-row items-center">
          <van-icon name="warning" size="18" color="#FF4040" class="mr-2" />
          <span>{{ msg }}</span>
        </div>
        <van-icon name="arrow" size="18" />
      </div>
    </div>
    <!-- 在停 homeParkingCharge 和充电信息 charging    -->
    <div v-if="(parkingList.length && homeParkingCharge === 1 && platBizType !== 2 ) ||(orderList.length && charging === 1 && platBizType !== 1) " class="mt-3 px-3">
      <div class="bg-white rounded-md">
        <van-swipe class="park-swipe" indicator-color="#4182F4" style="border-radius: 6px;">
          <template v-if="orderList.length && charging === 1 && platBizType !== 1">
            <van-swipe-item v-for="(item, index) in orderList" :key="'orderList' + index">
              <div class="blue-container" @click="goDetail(item.orderNo)">
                <div
                  class="flex flex-row items-center pb-3 text-gray-700"
                  style="border-bottom: 1px dashed rgba(65, 130, 244, 0.5)"
                >
                  <p class="text-base font-semibold">{{ item.formatPlateNo || "正在充电…" }}</p>
                  <van-tag v-if="item.formatPlateNo" round type="primary" color="#0ECCAF" class="ml-3"
                    >正在充电</van-tag
                  >
                </div>
                <div class="relative mt-3">
                  <div class="absolute text-sm" style="top: 0; right: 0; color: #4182f4">详情</div>
                  <p>
                    <van-icon name="clock" color="#4182F4" />
                    <span class="ml-2 text-sm text-gray-500">{{ item.startTime }}</span>
                  </p>
                  <p>
                    <van-icon name="location" color="#4182F4" />
                    <span class="ml-2 text-sm text-gray-500">{{ item.stationName }}</span>
                  </p>
                </div>
              </div>
            </van-swipe-item>
          </template>
          <template v-if="parkingList.length && homeParkingCharge === 1 && platBizType !== 2">
            <van-swipe-item v-for="(item, index) in parkingList" :key="'parkingList' + index">
              <div class="blue-order-container" @click="goParkDetail(item)">
                <div
                  class="flex flex-row justify-between items-center text-gray-700 parking-item-title"
                >
                  <p class="text-base font-semibold">{{ item.formatPlateNo }}</p>
                </div>
                <div class="parking-item-content">
                  <p>
                    <van-icon name="clock" color="#4182F4" />
                    <span class="ml-2 text-sm text-gray-500">{{ item.parkStartTime }}</span>
                  </p>
                  <p>
                    <van-icon name="location" color="#4182F4" />
                    <span class="ml-2 text-sm text-gray-500">{{ item.parkName }}</span>
                  </p>
                </div>
              </div>
            </van-swipe-item>
          </template>
        </van-swipe>
      </div>
    </div>
    <!-- 添加车辆信息 登录且车牌个数为0 -->
    <div v-if="showAdd" class="w-full" @click="goAddCar">
      <div class="flex flex-col justify-center add-bg">
        <p class="text-sm" style="color: rgba(255, 255, 255, 0.8)">您还未添加车辆信息</p>
        <div
          class="flex flex-row justify-center items-center mt-2 px-2 py-1 bg-white rounded-full"
          style="width: 115px; color: #4182f4"
        >
          <van-icon name="plus" />
          <p class="ml-2 text-sm">添加车辆</p>
        </div>
      </div>
    </div>
    <!-- 资讯 -->
    <news-list v-if="newsFlag === 1"></news-list>
    <!-- 附近停车点 -->
    <div v-if="platBizType === 1 || platBizType === 3" class="mt-3 px-3">
      <div class="px-3 bg-white rounded-md">
        <div
          class="flex flex-row justify-between items-center py-4"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.03)"
        >
          <div>
            <p class="font-semibold text-base text-gray-700">附近找到{{ parkNum }}个停车点</p>
            <p>
              <van-icon name="location" color="#4182F4" />
              <span class="ml-1 text-sm" style="color: rgba(0, 0, 0, 0.4)">{{ address }}</span>
            </p>
          </div>
          <img
            src="../assets/mapSearch.png"
            alt=""
            style="width: 50px; height: 40px"
            @click="search"
          />
        </div>
        <div
          v-for="(marker, index) in parkingItems"
          :key="index"
          class="flex flex-row justify-between items-center py-4"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.03)"
          @click="goParkingDetail(marker)"
        >
          <div class="list-left">
            <p class="park-name" :class="!marker.isOnline ? '_gray' : ''">{{ marker.parkName }}</p>
            <p class="park-add">{{ marker.parkAddr }}</p>
            <div v-if="marker.isTotal" class="park-spaceNum dis-flex">
              <p>
                总车位数：<span class="_hold">{{ marker.totalParkSpaceNum }}</span>
              </p>
              <p v-if="!wrongTimePackage && !wrongTimeSubscribe && monthActive">
                总车位数：<span class="_hold">{{ marker.totalParkSpaceNum }}</span>
              </p>
            </div>
            <p
              v-if="marker.isTotal && marker.description"
              style="
                font-size: 12px;
                color: #666;
                max-width: 250px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              class="parking-desc"
            >
              {{ marker.description }}
            </p>
            <p v-if='marker.supportBook&&marker.isOnline ' class="park-spaceNum dis-flex">
              <span>{{ marker.leftBookSpaceNumDesc}}</span>
            </p>
            <p v-if="!marker.isTotal" class="park-spaceNum dis-flex">
              <span v-if="marker.roadside && !wrongTimePackage && !wrongTimeSubscribe">
                总车位数：<span class="_hold">{{ n.totalParkSpaceNum }}</span>
              </span>
              <span v-if="!marker.roadside && !wrongTimePackage && !wrongTimeSubscribe">
                {{ marker.isOnline ? marker.leftParkSpaceNum + "个空闲车位" : marker.isOnlineStr }}
              </span>
              <span v-if="marker.description" class="parking-desc">
                &nbsp;•&nbsp;{{ marker.description }}
              </span>
            </p>
            <div class="park-fuctype-content">
            <p
              v-if="
                marker.isOnline &&
                marker.supportBag &&
                !marker.supportDiffTimeBag &&
                !marker.supportDiffTimeBook
              "
              class="park-fuctype"
            >
              可包月
            </p>
            <p
              v-if=" marker.supportBook
              "
              class="park-fuctype"
            >
              可预约
            </p>
            <p v-if="marker.supportDiffTimeBag && !marker.supportDiffTimeBook" class="park-fuctype">
              错时包月
            </p>
            <p v-if="!marker.supportDiffTimeBag && marker.supportDiffTimeBook" class="park-fuctype">
              错时预约
            </p>
            <p v-if="marker.supportDiffTimeBag && marker.supportDiffTimeBook" class="park-fuctype">
              错时包月·错时预约
            </p>
            </div>
            <p v-if="monthActive && marker.isOnline" class="park-spaceNum">
              {{ marker.leftBagSpaceNumDesc }}
            </p>
            <p v-if="chargeActive" class="park-spaceNum">{{ marker.leftChargeSpaceNumDesc }}</p>
            <p v-if="wrongTimePackage" class="park-spaceNum">
              {{ marker.diffTimeBagLeftNumDesc }}
            </p>
            <p v-if="wrongTimeSubscribe" class="park-spaceNum">
              {{ marker.diffTimeBookLeftNumDesc }}
            </p>
          </div>
          <div class="flex flex-col items-center" @click.stop="openBMap(marker)">
            <img src="../assets/home-location.png" alt="" width="35" />
            <p class="mt-1 text-sm" style="color: rgba(0, 0, 0, 0.4)">
              {{ marker.distance | changeNum }}
            </p>
          </div>
        </div>
        <p
          v-if="(platBizType === 1 || platBizType === 3) && parkingItems.length"
          class="p-3 text-blue-light text-xs text-center"
          @click="goSearch"
        >
          更多停车点
        </p>
        <p v-else class="p-3 text-gray-500 text-xs text-center">{{ errorString }}</p>
      </div>
    </div>
    <!-- 附近充电站 -->
    <div v-if="platBizType === 2" class="mt-3 px-3">
      <div class="px-3 bg-white rounded-md">
        <div
          class="flex flex-row justify-between items-center py-4"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.03)"
        >
          <div>
            <p class="font-semibold text-base text-gray-700">附近找到{{ stationNum }}个充电站</p>
            <p>
              <van-icon name="location" color="#4182F4" />
              <span class="ml-1 text-sm" style="color: rgba(0, 0, 0, 0.4)">{{ address }}</span>
            </p>
          </div>
          <img
            src="../assets/mapSearch.png"
            alt=""
            style="width: 50px; height: 40px"
            @click="goStationSearch"
          />
        </div>
       
        <div
          v-for="(item, index) in stationItems"
          :key="index"
          class="flex flex-row justify-between items-center py-4"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.03)"
        >
          <div @click="goStationDetail(item)">
            <p class="font-semibold text-base text-gray-700">{{ item.stationName }}</p>
            <p class="station-address">
              {{ item.stationAddr }}
            </p>
            <div class="station_price">
                  <span>{{ item.currentPrice }}</span><span>&nbsp;&nbsp;元/度</span>
                </div>
                <div class="stations">
                  <div v-if="item.quickChargingInfo.totalNum !== 0" class="quick-charging">
                    <img src="./../assets/map/快充面.png">
                    <p>
                      <span>闲</span><span>{{ item.quickChargingInfo.leftNum }}/</span><span>{{ item.quickChargingInfo.totalNum
                      }}</span>
                    </p>
                  </div>
                  <div v-if="item.slowChargingInfo.totalNum !== 0" class="slow-charging">
                    <img src="./../assets/map/慢充面.png">
                    <p>
                      <span>闲</span><span>{{ item.slowChargingInfo.leftNum }}/</span><span>{{ item.slowChargingInfo.totalNum
                      }}</span>
                    </p>
                  </div>
                </div>
          </div>
          <div class="flex flex-col items-center" @click.stop="openBMap(item)">
            <img src="../assets/home-location.png" alt="" width="35" />
            <p class="mt-1 text-sm" style="color: rgba(0, 0, 0, 0.4)">
              {{ item.distance | changeNum }}
            </p>
          </div>
        </div>
       <p v-if="stationItems.length" class="p-3 text-gray-500 text-xs text-center" @click="goStationSearch">
        更多充电站
       </p>
        <p v-else class="p-3 text-gray-500 text-xs text-center">无更多充电站</p>
      </div>
    </div>
    <!-- 选择导航 -->
    <div v-if="goMap" class="js_dialog" id="androidDialog2" style="opacity: 1">
      <div class="weui-mask"></div>
      <div class="weui-dialog weui-skin_android">
        <div class="weui-dialog__bd">确定对停车点进行导航么？</div>
        <div class="weui-dialog__ft">
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click.stop="cancel"
            >取消</a
          >
          <a
            v-if="!isWST"
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('高德')"
            >高德地图</a
          >
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('百度')"
            >百度地图</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef */
import api from '../api/home.js'
import API from '@/api/dynamicRouter.js'
import api_login from '@/api/login.js'
import api_mine from '@/api/mine.js'
import api_map from '@/api/map.js'
import store from '../store/index.js'
import weui from 'weui.js'
import { setJsapiSign, setAMap, JumpToMapApp, setBMapWebgl } from '../utils/index'
import { clientTYPE } from '../utils/constant.js'
import 'swiper/dist/css/swiper.css'
import _axios from '@/utils/service'
import wx from 'weixin-js-sdk'
import platenoInput from '@/components/platenoInput'
import newsList from '@/components/newsList.vue'
import {getCookie} from '@/utils/index.js'
import wstLogin from '@/utils/wstLogin.js'
import {transformFromGCJToBaidu}  from "@/utils/WSCoordinate.js"
const img = require('@/assets/hikPark.jpg')

export default {
  name: 'home',
  components: {
    platenoInput,
    newsList
  },
  data() {
    return {
      address: '',
      errorString: '无更多停车点',
      parkingItems: [],
      parkNum: 0,
      adList: [],
      headerColor: '#098CFF',
      loopList: [],
      column: 4,
      driverId: '',
      chargeInfo: {
        time: '2018-09-12 16:01',
        plateNo: '浙A·12345',
        description:
          '星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场星光大道东停车场',
        isFree: true
      },
      newsFlag: 0,
      swiperOption: {
        loop: false,
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
          delay: 3000, //自动切换的时间间隔，单位ms
          reverseDirection: false, //开启反向自动轮播。
          waitForTransition: true //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        }
      },
      orderList: [], // 充电的订单
      parkingList: [], // 在停的订单
      showAdd: false,
      msg: '',
      mapFlag: 1,
      goMap: false,
      platBizType: 1,
      stationNum: 0,
      stationItems: [],
      payForOthers: 0,
      homeParkingCharge: 0,
      charging: 0,
      ifLogin: getCookie('token'),
      wrongTimePackage: false,
      monthActive: false,
      chargeActive: false,
      wrongTimeSubscribe: false,
      hasShowPosition: false
    }
  },
  computed: {
    isWST() {
      return localStorage.getItem('clientType') == clientTYPE.WST
    }
  },
  created() {
    if (this.isWST && !this.ifLogin) {
      // 皖事通登录
      wstLogin.login().then(() => {
        this.ifLogin = getCookie('token')
      })
    }
    // 获取首页菜单配置
    this.getHomeFuncEntries()
    this.getCardNum()
    this.getMapType()
    if(this.ifLogin) {
      this.getMsp()
      this.getParkingList()
    }
    api_mine.getMenu().then((resp) => {
      this.newsFlag = resp.data.news
      this.payForOthers = resp.data.payForOthers
      this.homeParkingCharge = resp.data.homeParkingCharge
      this.charging = resp.data.charging
    })
  },
  mounted() {
    const self = this
    setJsapiSign(store).then(() => {
      if (localStorage.getItem('clientType') == clientTYPE.WX) {
        /* 微信公众号渠道进来，由微信获取地理位置 */
        self.WXgetLocation()
      } else {
        /* 非微信公众号，等待500ms百度地图组件加载后，根据url中提供的地理位置进行定位 */
        this.getLocation()
      }
      // const script = document.createElement('script');
      // script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=09c0ab33b93f77aa648376149e53afc8';
    })
  },
  filters: {
    changeNum(val) {
      let num
      val > 999 ? (num = `${(val / 1000).toFixed(2)}km`) : (num = `${val}m`)
      return num
    }
  },
  methods: {
    getHomeFuncEntries() {
      api.homeFuncEntries({token:getCookie('token')}).then(res=>{
        let list=res.data.list||[]
        list.forEach((item) => {
          item.icon = 'data:image/png;base64,' + item.icon
        })
        if (this.isWST) {
          list = list.filter(item => (item.entryId !== 'OPEN_WITHHOLD' && !item.url))
        }
        this.column=res.data.column||4
        this.loopList=list
      })
    },
    goMenuAll() {
      this.$router.push('/menuAll')
    },
    goPay() {
      this.$router.push('/multiPayPage?arrearsOnly=1')
    },
    cancel() {
      this.goMap = false
    },
    getMapType() {
      api_map.getMapType().then((resp) => {
        this.mapFlag = resp.data.type
      })
    },
    openBMap(item) {
      if (this.mapFlag == 1) {
        this.primary('高德', item)
      } else if (this.mapFlag == 2) {
        this.primary('百度', item)
      } else if (this.mapFlag == 3) {
        this.goMap = true
      }
    },
    primary(val, parkItem) {
      this.goMap = false
      let originPos = {
        lat: localStorage.getItem('lat'),
        lng: localStorage.getItem('lng')
      }
      JumpToMapApp(
        originPos,
        { lat: parkItem.latitude, lng: parkItem.longitude },
        parkItem.parkName,
        val
      )
    },
    goParkingDetail(item) {
      this.$router.push({ name: 'parkingDetail', query: { parkId: item.parkId } })
    },
    goSearch() {
      this.$router.push({ path: '/search' })
    },
    goStationSearch() {
      this.$router.push('/map?isFromHome=1')
    },
    search() {
      this.$router.push({ path: '/search?type=1' })
    },
    goParkDetail(item) {
      if (item.uniqueId && !this.swipeLoading) {
        this.$router.push('/payPage?uniqueId=' + item.uniqueId + '&parkId=' + item.parkId)
      }
    },
    async getMsp() {
      if (getCookie('token')) { 
        let res = await _axios('/charge/v2/api/parkOrders/msp', {
          params: {
            pageNo: 1,
            pageSize: 999,
            requestType: 2
          }
        })
        if (res.data.results && res.data.results.length) {
          let formatPlateNoArr = res.data.results.map((val) => val.formatPlateNo)
          let tempSetArr = [...new Set(formatPlateNoArr)]
          if (tempSetArr.length == 1) {
            this.msg = `${res.data.results[0].formatPlateNo}有${res.data.results.length}笔欠费，请尽快处理`
          } else {
            this.msg = `您有${res.data.results.length}笔欠费，请尽快处理`
          }
        }
      }
    },
    async getParkingList() {
      if (getCookie('token')) {  
        let res = await _axios('/charge/v2/api/parkOrders/msp', {
          params: {
            pageNo: 1,
            pageSize: 999,
            requestType: 1
          }
        })
        this.parkingList = res.data.results
      }
    },
    goAddCar() {
      this.$router.push('/addCar')
    },
    async getCardNum() {
      if (getCookie('token')) {
        let res = await _axios('/driver/v2/api/plateCount')
        if (res.data.count == 0) {
          this.showAdd = true
        }
      }
    },
    goDetail(orderNo) {
      this.$router.push(`/chargingResults?orderNo=${orderNo}`)
    },
    async getOrderList() {
      let res = await _axios('/cps/v2/api/chargingOrders/msp', {
        params: {
          requestType: 1,
          pageNo: 1,
          pageSize: 20
        }
      })
      this.orderList = res.data.results
    },
    getbtnList() {
      // 获取菜单按钮权限
      return new Promise((resolve) => {
        const self = this
        self.$store.dispatch('commitMenuCofig').then((btnList) => {
          self.platBizType = btnList.platBizType
          let menuArr = []
          if(btnList.walletPlan === 2 && self.$store.getters.menuCofig.supportBalance) { // 我的钱包
            menuArr.push('walletPlan')
          } else if(btnList.homeRecharge && (btnList.walletPlan !== 2 || !self.$store.getters.menuCofig.supportBalance)) { // 账户充值
            menuArr.push('homeRecharge')
          }
          for (let key in btnList) {
            if (
              key == 'walletPlan' &&
              self.$store.getters.menuCofig.supportBalance &&
              btnList[key] === 2
            ) {
              menuArr.push(key)
            }
            // if (key != 'walletPlan' && btnList[key]) {
            //   menuArr.push(key)
            // }
            // 车场包期  错时共享 开通无感 客服帮助 优惠券 停车
            if((key == 'bagVehicle' ||key == 'diffTime' || key =='mineBook' || key== 'homeEtc' || key == 'homeCoupon' || key == 'homeCustomerService' ) && btnList[key] === 1 && btnList.platBizType !== 2) {
              menuArr.push(key)
            }
            // 找充电桩 充电 
            if(key == 'charging' && btnList[key] === 1 && btnList.platBizType !== 1 )  {
              menuArr.push(key)
            }
            // 开具发票 车辆绑定 停车 + 充电
            if(( key == 'homeInvoice'|| key == 'homeVehicle') && btnList[key] === 1) {
              menuArr.push(key)
            }
          }
          if (self.$store.getters.menuCofig.charging === 1 && this.ifLogin) {
            self.getOrderList()
          }
          resolve()
        })
      })
    },
    getLocation() {
      const self = this
      if (navigator.geolocation) {
        const options = {
          enableHighAccuracy: true,
          timeout: 1500,
          maximumAge: 0
        }
        navigator.geolocation.getCurrentPosition(self.showPosition, self.showError, options)
        setTimeout(() => { // 解决安卓系统webview环境下，不执行回调的问题，手动调用showPosition方法
          self.showPosition()
        }, 1600)
      } else {
        alert('浏览器不支持地理定位。')
      }
    },
    showPosition(position) {
      if (this.hasShowPosition) { // 如果已经调用过则不调用
        return
      }
      this.hasShowPosition = true
      // 默认给广德的经纬度
      var lat = position?.coords?.latitude || 30.876054 //纬度
      var lng = position?.coords?.longitude || 119.422889 //经度
      // lng = 120.216603;
      // lat = 30.208999;
      localStorage.setItem('lat', lat)
      localStorage.setItem('lng', lng)
      this.getAd(lng.toString(), lat.toString())
      if(this.platBizType === 1 || this.platBizType === 3) { // 仅停车或停车+充电
        this.getNearByParks(lng.toString(), lat.toString())
      } else if(this.platBizType === 2) { // 仅充电)
        this.getNearbyStations(lng.toString(), lat.toString())
      }
    },
    showError(error) {
      this.errorString = '停车点查询失败'
    },
    getAdsList(city) {
      let self = this
      if (!city) {
        city = '全国'
      }
      api
        .getAds({ cityName: city })
        .then((res) => {
          if (res.data.results.length > 0) {
            self.adList.splice(0, self.adList.length)
            res.data.results.forEach((item) => {
              self.adList.push(item)
            })
          } else {
            self.adList.splice(0, self.adList.length)
            self.adList.push({ picUrl: img, bgColor: '#098CFF' })
          }
        })
        .catch(() => {
          self.adList.splice(0, self.adList.length)
          self.adList.push({ picUrl: img })
        })
    },
    // 首页获取附近停车点接口
    getNearByParks(lng, lat) {
      // 杭州市经纬度
      // lng = 120.216603;
      // lat = 30.208999;
      let self = this
      api
        .getNearByParks({
          destLng: lng,
          destLat: lat
        })
        .then((res) => {
          if (res.data.results) {
            self.parkNum = res.data.results.length
            self.parkingItems = res.data.results.filter((value, index) => index < 5)
          }
        })
    },
    // 首页获取附近充电站
    getNearbyStations(lng, lat) {
      api_map.getNearbyStations({ destLng: lng, destLat: lat }).then((res) => {
        if (res.data.results) {
          this.stationNum = res.data.results.length
          this.stationItems = res.data.results.filter((value, index) => index < 5)
        }else {
          this.stationNum = 0
          this.stationItems = []
        }
        
      })
    },
    getAd(lng, lat) {
      const self = this
      if(this.mapFlag==2){
        setBMapWebgl().then(()=>{
          var BGeocoder = new BMap.Geocoder()
          const point = new BMap.Point(lng, lat)
          BGeocoder.getLocation(point, function(result) {
            if (result) {
              const { city = '', province = '' } = result.addressComponents
              const locationCity = city || province
              // 搜索页和到导航时需要
              localStorage.setItem('locationCity', locationCity)
              self.address = result.address
              self.getAdsList(result.addressComponents.province)
            }
          })
        })
      }else{
        setAMap().then(() => {
          var map = new AMap.Map('mapContainer')
          map.plugin('AMap.Geocoder', function() {
            var geocoder = new AMap.Geocoder({
              city: '010'
            })
            var lnglat = [lng, lat]
            geocoder.getAddress(lnglat, function(status, result) {
              if (status === 'complete' && result.info === 'OK') {
                // 保存定位的默认城市
                localStorage.setItem(
                  'locationCity',
                  result.regeocode.addressComponent.city || result.regeocode.addressComponent.province
                )
                self.getAdsList(result.regeocode.addressComponent.province)
                self.address =
                  result.regeocode.addressComponent.province +
                  result.regeocode.addressComponent.district +
                  result.regeocode.addressComponent.township
              } else {
                self.getAdsList('安徽省')
              }
            })
          })
        })
      }
    },
    WXgetLocation() {
      const self = this
      wx.getLocation({
        isHighAccuracy: true,
        altitude: 'true',
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          let lng=res.longitude.toString()
          let lat=res.latitude.toString()
          
          if(self.mapFlag === 2){
            let marker = transformFromGCJToBaidu(lat,lng)
            lat=marker.latitude
            lng=marker.longitude
          }
          localStorage.setItem('lng',lng )
          localStorage.setItem('lat',lat )
          if(self.platBizType === 1 || self.platBizType === 3) { // 仅停车或停车+充电
            self.getNearByParks(lng, lat)
          }else if(self.platBizType === 2) { // 仅充电
            self.getNearbyStations(lng,lat)
          }

          self.getAd(lng, lat)
        },
        fail: function(err) {
          console.log('获取微信定位失败：', err)
          this.errorString = '停车点查询失败'
        }
      })
    },
    goNewPage(item) {
      if (item.entryName === '停车缴费') {
        this.$router.push('/scanPayPage')
      } else if (item.entryId === 'BAG') {
        if (
          this.$store.getters.menuCofig.bagPlan === 1 ||
          this.$store.getters.menuCofig.bagPlan === 3
        ) {
          // 老方案。跳转停车场列表
          this.$router.push('/nearbyBagParks')
        } else if (this.$store.getters.menuCofig.bagPlan === 2) {
          // 新方案、跳转规则列表
          this.$router.push('/nearbyBagRules')
        }
      } else if (item.entryId === 'DIFF_TIME') {
        api.checkIntegral().then(res=>{
          if(!res.data.allow) {
            weui.confirm(res.data.reason, ()=>{
              this.$router.push('/integral')
            }, function() {
            })
          }else{
            this.$router.push('/wrongTimeShare')
          }
        })
      } else if (item.entryId === 'ACCOUNT_RECHARGE') {
        this.$router.push('/accountBalance')
      } else if (item.entryId === 'VEHICLE_BINDING') {
        this.$router.push('/carManage')
      } else if (item.entryId === 'ACCOUNT_RECHARGE') {
        this.$router.push('/wallet')
      } else if (item.entryId === 'CAR_BOOK') {
        this.$router.push('/bookParks/index')
      } else if (item.entryId === 'OPEN_WITHHOLD') {
        this.$router.push('/sencelessPayment')
      } else if (item.entryId === 'CHARGING_STATION') {
        this.$router.push('/map?isFromHome=1')
      } else if (item.entryId === 'INVOICE') {
        this.$router.push('/invoiceManage')
      } else if (item.entryId === 'COUPON') {
        this.$router.push('/unused')
      } else if (item.entryId === 'PARK_COLLECTION'){
        this.$router.push('/collect')
      }else if (item.entryId === 'CUSTOMER_SERVICE') {
        this.$router.push('/customerService/index')
      } 
      else {
        if (item.url?.indexOf('thirdPartyServiceStation') > -1) {
          const stationUrl = `/thirdPartyServiceStation?${item.url.split('?')[1]}&entryName=${item.entryName}`
          this.$router.push(stationUrl)
        }else if (item.url && !item.needLogin) {
          window.location.href = item.url
        } else if (item.needLogin) {
          this.$router.push('/login')
        } else {
          // 获取跳转参数driverId
          api_login.getUserInfo().then((resp) => {
            if (parseInt(resp.code) === 200) {
              this.driverId = resp.data.driverId
            } else {
              this.driverId = ''
            }
            let params = {
              pageId: item.pageId,
              driverId: this.driverId
            }
            API.getWebPageUrl(params).then((res) => {
              if (res && parseInt(res.code) === 200) {
                window.location.href = res.data.url
              }
            })
          })
        }
      }
    },
    updateHeaderColor(val) {
      if (this.adList[val]) {
        this.headerColor = this.adList[val].bgColor
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/css/tailwindcss.less";
.top-bg {
  height: 190px;
  width: 100%;
  /* 
  background-image: url("../assets/top-bg.png");
  background-size: 100% 100%;
  */
  background-image: linear-gradient(270deg, #4C81FF 8%, #59BF98 92%);
}
.top-bg::after {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -15px;
  height: 30px;
  width: 100%;
  border-radius: 50%;
  background: rgb(239, 240, 244);
}
.my-swipe .van-swipe-item {
  height: 195px;
}
.add-bg {
  padding-left: 40px;
  width: 100%;
  height: 112px;
  background-image: url("../assets/addCarinfo.png");
  background-size: 100% 100%;
}
.blue-container {
  position: relative;
  background: #f2f6ff;
  border-radius: 6px;
  .parking-item-title {
    height: 32px;
    padding: 0 16px;
    background-image: linear-gradient(270deg, #4C81FF 8%, #59BF98 92%);
    font-size: 16px;
    color: #FFF;
    letter-spacing: -0.62px;
    font-weight: 500;
    font-family: PingFangSC-Medium;
  }
  .parking-item-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 48px;
    padding: 0 16px;
    background-image: linear-gradient(180deg, rgba(255,255,255,0.88) 0%, rgba(255,255,255,0.88) 100%);
    box-shadow: 0px 2px 10px 0px rgba(226,226,226,0.5);
    .money-wrap {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #333;
      letter-spacing: -0.57px;
      text-align: right;
      font-weight: 400;
      .money {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #FF952C;
        letter-spacing: -0.76px;
        text-align: right;
        font-weight: 500;
      }
    }
  }
}
.blue-order-container {
  position: relative;
  background: #f2f6ff;
  border-radius: 6px;
  .parking-item-title {
    height: 32px;
    padding: 0 16px;
    background-image: linear-gradient(270deg, #4C81FF 8%, #59BF98 92%);
    font-size: 16px;
    color: #FFF;
    letter-spacing: -0.62px;
    font-weight: 500;
    font-family: PingFangSC-Medium;
  }
  .parking-item-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 16px;
    background-image: linear-gradient(180deg, rgba(255,255,255,0.88) 0%, rgba(255,255,255,0.88) 100%);
    box-shadow: 0px 2px 10px 0px rgba(226,226,226,0.5);
    .money-wrap {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #333;
      letter-spacing: -0.57px;
      text-align: right;
      font-weight: 400;
      .money {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #FF952C;
        letter-spacing: -0.76px;
        text-align: right;
        font-weight: 500;
      }
    }
  }
}
.park-swipe .van-swipe-item {
  /* padding: 12px 12px 32px 12px; */
}
.arrears-hint {
  padding: 0 10px 0 16px;
  height: 32px;
  background: #FFF4E9;
  border: 0.5px solid #FF952C;
}
.list-left {
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .park-name {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    &._gray {
      color: #999999;
    }
  }

  .park-add {
    font-size: 14px;
    color: #999999;
    margin-top: 3px;
  }

  .station_price {
    span:nth-child(1) {
      font-size: 16px;
      color: #3ca4ff;
    }

    span:nth-child(2) {
      font-size: 14px;
      color: #999999;
    }
    
  }
  .dis-flex {
    display: flex;
  }

  .park-spaceNum {
    font-size: 14px;
    color: #999999;

    .parking-desc {
      display: inline-block;
      width: 180px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      color: #999999;
    }

    ._hold {
      font-size: 15px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .park-fuctype-content {
    display: flex;
    flex-direction: row;
  }
  .park-fuctype {
    background: rgba(65, 130, 244, 0.1);
    border: 1px solid rgba(65, 130, 244, 1);
    border-radius: 12px;
    font-size: 12px;
    color: #4182f4;
    letter-spacing: 0;
    padding: 2px 9px;
    width: fit-content;
    margin-top: 6px;
    margin-right: 6px;
  }
}
    .stations {
    display: flex;

    .quick-charging,
    .slow-charging {
      display: flex;
      font-size: 12px;
      color: #999999;
      text-align: center;

      p {
        padding: 0px 5px;
        height: 25px;
        line-height: 25px;

        span:nth-child(1) {
          font-size: 14px;
          color: #3ca4ff;
        }
        span:nth-child(2) {
          font-size: 14px;
          color: #3ca4ff;
          margin-left: 3px;
        }
      }
    }

    .quick-charging p {
      background: url("./../assets/map/快充线.png") center no-repeat;
      background-size: 100% 100%;
      min-width: 50px;
    }

    .slow-charging {
      margin-left: 8px;

      p {
        background: url("./../assets/map/慢充线.png") center no-repeat;
        background-size: 100% 100%;
        min-width: 50px;
      }
    }

    img {
      width: 40px;
      height: 25px;
    }
  }
</style>